// src/components/AnalyticsPageTracker.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendPageView } from "@/utils/gaUtil";

export default function AnalyticsPageTracker() {
  const location = useLocation();

  useEffect(() => {
    try {
      sendPageView({
        pathname: location.pathname,
        search: location.search,
        title: document.title,
      });
    } catch (e) {
      
    }
  }, [location.pathname]);

  return null;
}